import axios from '@/api/axios'

const getSportSchools = (params) => {
  return axios.get(`/sportsSchools`, {params})
}

const getSportSchoolsMore = (params) => {
  return axios.get(`/sportsSchools`, {params})
}

const addSportSchools = (schools) => {
  return axios.post(`/sportsSchools`, schools)
}

const updateSportSchools = (school) => {
  return axios.put(`/sportsSchools/${school.id}`, school)
}

const getSportSchool = (id) => {
  return axios.get(`/sportsSchools/${id}`)
}

const deleteSportSchool = (id) => {
  return axios.delete(`/sportsSchools/${id}`)
}

export default {
  getSportSchools,
  addSportSchools,
  getSportSchool,
  updateSportSchools,
  deleteSportSchool,
  getSportSchoolsMore,
}
